import React from 'react'
import { useIntl } from 'react-intl'
import { Button } from '@contrast-security-inc/design-system-buttons'
import { css } from '@emotion/css'

export function DiagnosticCollectionButtonEnable({ disabled, onClick }) {
  const { formatMessage } = useIntl()
  return (
    <Button
      data-testid={'action_diagnostic_enable'}
      isDisabled={disabled}
      onClick={onClick}
      className={css`
        font-size: 14px;
      `}
    >
      {formatMessage({ id: 'action_diagnostic_enable' })}
    </Button>
  )
}
